import React from 'react';
import { isVideoDeviation, scaleToSize } from '../../../_helpers';
import MediaService from '../../../../utils/DeviationMediaService';
import BlurredBackground from '../BlurredBackground/BlurredBackground';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import paywallStyles from './Paywall.scss';
const PaywallLayout = ({ icon, title, text, button, deviation, width, height })=>{
    const background = MediaService.getThumbSet(deviation).find((thumb)=>thumb.type === '400T');
    const fullImage = MediaService.getFullviewForSize(deviation, width, height);
    const childBoxSize = fullImage ? scaleToSize(fullImage, {
        width,
        height
    }) : {
        width,
        height
    };
    const isVideo = isVideoDeviation(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: paywallStyles['root']
    }, /*#__PURE__*/ React.createElement("div", {
        style: childBoxSize,
        className: paywallStyles['blocked-placeholder']
    }, background && /*#__PURE__*/ React.createElement(BlurredBackground, {
        imageUrl: background.src
    }), /*#__PURE__*/ React.createElement("div", {
        className: paywallStyles['blocked-wrap']
    }, /*#__PURE__*/ React.createElement("div", {
        className: paywallStyles['blocked-icon']
    }, icon), title && /*#__PURE__*/ React.createElement("div", {
        className: paywallStyles['blocked-title']
    }, isVideo && /*#__PURE__*/ React.createElement(VideoIcon, {
        className: paywallStyles['blocked-title-icon']
    }), /*#__PURE__*/ React.createElement("span", null, title)), text && /*#__PURE__*/ React.createElement("div", {
        className: paywallStyles['blocked-text']
    }, text), button)));
};
PaywallLayout.displayName = 'PaywallLayout';
export default PaywallLayout;
